import { useQuery } from "@tanstack/react-query";
import { t } from "ttag";

import { appQueriesStore } from "@/app/api";
import { ScreenLayout } from "@/app/components/layouts";
import { LogoLoader } from "@/shared/components";
import { usePageTitle } from "@/shared/hooks";
import { IS_WEB_VIEW } from "@/shared/lib";
import { EditProfileButton } from "./components";
import {
  Biometric,
  Contact,
  InsuranceCard,
  ProfileOverviewHeader,
} from "./sections";
import { GeneralInformation } from "./sections/general-information";

export const MyProfile = () => {
  usePageTitle(t`Profile`);

  const { data: patient, isLoading } = useQuery(appQueriesStore.patient);

  return (
    <ScreenLayout>
      <ProfileOverviewHeader />

      <LogoLoader show={isLoading} withOverlay />

      {patient && (
        <div className="grid gap-4 xl:grid-cols-2">
          {IS_WEB_VIEW && <Biometric />}

          <GeneralInformation patient={patient} />

          <Contact patient={patient} />

          <div className="xl:col-span-2">
            <InsuranceCard policy={patient.policy} />
          </div>
        </div>
      )}

      <EditProfileButton />
    </ScreenLayout>
  );
};
